import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { setNumberLanguage } from "utils/formatters/formatNumber";
import { isDev } from "utils/isDev";
import { getAutomaticLanguage } from "utils/language/getAutomaticLanguage";

const baseURL = import.meta.env.BASE_URL;

// Numbers are shown with the decimal separator of the language (also of the first one, set by init)
i18n.on("languageChanged", setNumberLanguage);

void i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: !!isDev,
    backend: {
      loadPath: `${baseURL}langs/{{lng}}/{{ns}}.json`,
    },
    lng: getAutomaticLanguage() ?? "en",
    fallbackLng: "en",
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
